import { ChartsPayload, RegionDataPayload } from '@eview/core/models/dashboard';
import { Action } from '@ngrx/store';

export enum EDashboardActions {
    GetRegionData = '[Dashboard] get regions data',
    GetRegionDataSuccess = '[Dashboard] get regions data success',
    GetRegionDataFailure = '[Dashboard] get regions data failure',
    GetChartsData = '[Dashboard] get charts data',
    GetChartsDataSuccess = '[Dashboard] get charts data success',
    GetChartsDataFailure = '[Dashboard] get charts data failure',
}

export class GetRegionData implements Action {
    readonly type = EDashboardActions.GetRegionData;
    constructor(public payload?: RegionDataPayload) { }
}

export class GetRegionDataSuccess implements Action {
    readonly type = EDashboardActions.GetRegionDataSuccess;
    constructor(public payload: any) { }
}

export class GetRegionDataFailure implements Action {
    readonly type = EDashboardActions.GetRegionDataFailure;
}

export class GetChartsData implements Action {
    readonly type = EDashboardActions.GetChartsData;
    constructor(public payload?: ChartsPayload) { }
}

export class GetChartsDataSuccess implements Action {
    readonly type = EDashboardActions.GetChartsDataSuccess;
    constructor(public payload: any) { }
}

export class GetChartsDataFailure implements Action {
    readonly type = EDashboardActions.GetChartsDataFailure;
}

export type DashboardActions = GetRegionData | GetRegionDataSuccess | GetRegionDataFailure | GetChartsData | GetChartsDataSuccess | GetChartsDataFailure;
